import React from 'react'

import ActivityIndicator from './activity-indocator'
import Card from './card'

type TLoading = {
  appear: boolean
  title?: string
  description?: string
}

export default function Loading({ appear, title, description }: TLoading) {
  return appear ? (
    <div
      className='fixed left-0 top-0 z-[999] flex h-screen w-screen flex-row items-center justify-center bg-pop-gray-1/50'
      data-testid='loading-indicator'
    >
      <div className='mx-auto flex flex-col gap-4 px-5 py-4 md:w-1/2 md:py-6 lg:w-1/2 lg:py-9 xl:w-1/3 xl:py-12'>
        <Card>
          <div className='flex flex-col items-center justify-center gap-2'>
            <ActivityIndicator size='large' />
            <h1 className='text-lg font-semibold'>{title || 'Loading'}</h1>
            <p className='text-sm font-normal text-pop-gray-2'>
              {description || 'Please wait while the content is loading'}
            </p>
          </div>
        </Card>
      </div>
    </div>
  ) : null
}
